<template>
     <svg class="svg-inline--fa fa-w-16" fill="none" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m9 6 6 6-6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" class="stroke-000000"></path></svg>
</template>